/**
 * Updating all text that has data-alsolis-text attribute.
 */
const alsolisTextEles = document.body.querySelectorAll('[data-alsolis-text]');
alsolisTextEles.forEach((ele) => {
  // if element has child eles, should traverse through all child eles
  if (ele.querySelector('*:not(:has(*))')) {
    ele.querySelectorAll('*:not(:has(*))').forEach((childEle) => {
      const words = childEle.textContent.split(' ');
      let newInnerHTML = '';
      words.forEach((word) => {
        if (word.toUpperCase() == 'ALSOLIS') {
          newInnerHTML = newInnerHTML + '<span class="alsolis-text">' + word + '</span>' + ' ';
        } else {
          newInnerHTML = newInnerHTML + word + ' ';
        }
      });

      childEle.innerHTML = newInnerHTML;
    })
  } else {
    const words = ele.textContent.split(' ');
    let newInnerHTML = '';
    words.forEach((word) => {
      if (word.toUpperCase() == 'ALSOLIS') {
        newInnerHTML = newInnerHTML + '<span class="alsolis-text">' + word + '</span>' + ' ';
      } else {
        newInnerHTML = newInnerHTML + word + ' ';
      }
    });

    ele.innerHTML = newInnerHTML;
  }

  ele.style.opacity = '1';
})

/**
 * A custom element that manages the main menu drawer.
 */
class HeaderDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.mobileMenu = this.querySelector('.header__mobile-menu');
    this.openButton = this.querySelector('.open-menu-button');
    this.closeButton = this.querySelector('.close-menu-button');
    this.bindedHandleKeyUp = this.handleKeyUp.bind(this);
    this.bindedHandleOpenButtonClick = this.handleOpenButtonClick.bind(this);
    this.bindedHandleCloseButtonClick = this.handleCloseButtonClick.bind(this);
    this.bindedHandleTransitionEnd = this.handleTransitionEnd.bind(this);
    this.bindedHandleMobileMenuClick = this.handleMobileMenuClick.bind(this);

    this.addEventListener('keyup', this.bindedHandleKeyUp);
    this.openButton.addEventListener('click', this.bindedHandleOpenButtonClick);
    this.closeButton.addEventListener('click', this.bindedHandleCloseButtonClick);
    this.mobileMenu.addEventListener('transitionend', this.bindedHandleTransitionEnd);
    this.mobileMenu.addEventListener('click', this.bindedHandleMobileMenuClick);
  }

  disconnectedCallback() {
    this.removeEventListener('keyup', this.bindedHandleKeyUp);
    this.openButton.removeEventListener('click', this.bindedHandleOpenButtonClick);
    this.closeButton.removeEventListener('click', this.bindedHandleCloseButtonClick);
    this.mobileMenu.removeEventListener('transitionend', this.bindedHandleTransitionEnd);
  }

  /**
   * Close the main menu drawer when the Escape key is pressed
   */
  handleKeyUp = (event) => {
    if (event.key !== 'Escape') return;

    this.close();
  };

  /**
   * Open menu when menu button clicked
   */
  handleOpenButtonClick = () => {
    this.open();
  }

    /**
   * Close menu when close button clicked
   */
  handleCloseButtonClick = () => {
    this.close();
  }

    /**
   * Close menu when overlay clicked
   */
  handleMobileMenuClick = (event) => {
    if (event.target.querySelector('.header__mobile-menu-content')) {
      this.close();
    }
  }

  /**
   * Update styling once mobile menu fully closed
   */
  handleTransitionEnd = () => {
    if (this.mobileMenu.classList.contains('closing')) {
      this.mobileMenu.classList.remove('closing');
      this.mobileMenu.classList.remove('open');
    }
  }


  /**
   * Open the closest drawer or the main menu drawer
   */
  open() {
    this.openButton.setAttribute('aria-expanded', 'true');
    this.closeButton.setAttribute('aria-expanded', 'true');
    this.mobileMenu.classList.add('open');
  }

  /**
   * Close the closest menu or submenu that is open
   */
  close() {
    this.openButton.setAttribute('aria-expanded', 'false');
    this.closeButton.setAttribute('aria-expanded', 'false');
    this.mobileMenu.classList.add('closing');
  }
}

customElements.define('header-drawer', HeaderDrawer);


/**
 * A custom element that manages centered text.
 */
class CenteredText extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.enButton = this.querySelector('.en-button');
    this.ptButton = this.querySelector('.pt-button');
    this.bindedHandleEnButtonClick = this.handleEnButtonClick.bind(this);
    this.bindedHandlePtButtonClick = this.handlePtButtonClick.bind(this);

    if (this.enButton && this.ptButton) {
      this.enButton.addEventListener('click', this.bindedHandleEnButtonClick);
      this.ptButton.addEventListener('click', this.bindedHandlePtButtonClick);
    }
  }

  disconnectedCallback() {
    if (this.enButton && this.ptButton) {
      this.enButton.removeEventListener('click', this.bindedHandleEnButtonClick);
      this.ptButton.removeEventListener('click', this.bindedHandlePtButtonClick);
    }
  }

  /**
   * Hide Portuguese when EN Button clicked
   */
  handleEnButtonClick = () => {
    this.enButton.setAttribute('aria-selected', 'true');
    this.ptButton.setAttribute('aria-selected', 'false');
  }

    /**
   * Hide English when PT Button clicked
   */
  handlePtButtonClick = () => {
    this.ptButton.setAttribute('aria-selected', 'true');
    this.enButton.setAttribute('aria-selected', 'false');
  }
}

customElements.define('centered-text', CenteredText);

/**
 * A custom element that manages collection grids.
 */
class CollectionGrid extends HTMLElement {
  constructor() {
    super();
  }

  applySize() {
    let firstSmallCardI = this.firstSmallCardI;
    this.querySelectorAll('[data-product-card-cont]').forEach((ele, i) => {
      if (i < firstSmallCardI) {
        ele.classList.add('big-card');
      } else if (i >= firstSmallCardI && i < firstSmallCardI + 4) {
        ele.classList.add('small-card');
      } else if (i >= firstSmallCardI + 4 && i < firstSmallCardI + 8) {
        ele.classList.add('big-card');
      }

      if (i == firstSmallCardI + 7) {
        firstSmallCardI = firstSmallCardI + 8;
      }
    })

    this.submitEnded = true;
    this.dispatchEvent(new Event("loadingDone"));
  }

  connectedCallback() {
    this.firstSmallCardI = Math.floor(Math.random() * 5);
    this.applySize();

    this.bindedHandleTransitionEnd = this.handleTransitionEnd.bind(this);
    this.bindedHandleLoadingDone = this.handleLoadingDone.bind(this);
    this.addEventListener('transitionend', this.bindedHandleTransitionEnd);
    this.addEventListener('loadingDone', this.bindedHandleLoadingDone);
  }

  disconnectedCallback() {
    this.removeEventListener('transitionend', this.bindedHandleTransitionEnd);
    this.removeEventListener('loadingDone', this.bindedHandleLoadingDone);
  }

  // for facet transition
  handleTransitionEnd = () => {
    this.transitionEnded = true;
    this.dispatchEvent(new Event("loadingDone"));
  }

  // for facet transition
  handleLoadingDone = () => {
    if (this.transitionEnded && this.submitEnded) {
      this.classList.remove('loading');
      document.querySelectorAll('facet-filters-form').forEach((ele) => ele.parentElement.classList.remove('open'));
      document.querySelectorAll('.facets__mobile-nav-item').forEach((ele) => ele.setAttribute('aria-expanded', 'false'));
      document.querySelectorAll('facet-filters-form button.facets__apply').forEach((ele) => ele.classList.remove('loading'));
    }
  }
}

customElements.define('collection-grid', CollectionGrid);

class ViewMoreGallery extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.button = this.querySelector('.product__view-more-button');
    this.buttonContent = this.querySelector('.product__view-more-button-content');
    this.viewMoreImages = this.querySelector('.product__view-more-images-cont');
    this.bindedHandleClick = this.handleClick.bind(this);
    this.button.addEventListener('click', this.bindedHandleClick);
  }

  disconnectedCallback() {
    this.button.removeEventListener('click', this.bindedHandleClick);
  }

  open() {
    this.buttonContent.textContent = "View less images";
    this.viewMoreImages.classList.add('open');
  }

  close() {
    this.buttonContent.textContent = "View more images";
    this.viewMoreImages.classList.remove('open');
  }

  handleClick(event) {
    this.viewMoreImages.classList.contains('open')? this.close() : this.open();
  }
}

customElements.define('view-more-gallery', ViewMoreGallery);

class ReadMoreDescription extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.button = this.querySelector('.product__description-view-more-button');
    this.buttonContent = this.querySelector('.product__description-view-more-button-content');
    this.description = this.querySelector('.product__description-content');
    this.descriptionContent = this.querySelector('.product__description-content .rte');

    this.bindedHandleClick = this.handleClick.bind(this);
    this.button.addEventListener('click', this.bindedHandleClick);

    if (this.descriptionContent.offsetHeight > 13 * parseInt(getComputedStyle(document.documentElement).fontSize)) {
      this.button.classList.remove('hidden');
    }
    this.resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        if (this.descriptionContent.offsetHeight > 13 * parseInt(getComputedStyle(document.documentElement).fontSize)) {
          this.button.classList.remove('hidden');
        } else {
          this.button.classList.add('hidden');
        }
      }
    });
    this.resizeObserver.observe(this.descriptionContent);
  }

  disconnectedCallback() {
    this.button.removeEventListener('click', this.bindedHandleClick);
    this.resizeObserver.disconnect();
  }

  open() {
    this.buttonContent.textContent = "Read less";
    this.description.classList.add('open');
    this.description.style.maxHeight = `${this.description.firstElementChild.offsetHeight}px`;
  }

  close() {
    this.buttonContent.textContent = "Read more";
    this.description.classList.remove('open');
    this.description.removeAttribute('style');
  }

  handleClick(event) {
    this.description.classList.contains('open')? this.close() : this.open();
  }
}

customElements.define('read-more-description', ReadMoreDescription);

class BreadcrumbsElement extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const pageTitle = document.referrer.split('/').at(-1).split('?')[0].replaceAll('-', ' ');

    if (this.querySelector('.referrer')) {
      if (pageTitle != '') {
        this.querySelector('.referrer').innerHTML = `<a href=${document.referrer}>${pageTitle}</a>`;
      } else {
        this.querySelector('.referrer').remove();
      }
    }

    this.style.opacity = '1';
  }
}

customElements.define('breadcrumbs-element', BreadcrumbsElement);

class SizeGuide extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.sizeGuideButton = this.querySelector('button.size-guide-button');
    this.closeSizeGuideButton = this.querySelector('button.close-size-guide-button');
    this.sizeGuideContainer = this.querySelector('.product__size-guide');

    document.documentElement.style.setProperty("--size-guide-width", `${this.sizeGuideContainer.clientWidth}px`);
    
    this.bindedHandleKeyUp = this.handleKeyUp.bind(this);
    this.bindedHandleClick = this.handleClick.bind(this);

    this.addEventListener('keyup', this.bindedHandleKeyUp);
    this.addEventListener('click', this.bindedHandleClick);

    this.resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        document.documentElement.style.setProperty("--size-guide-width", `${entry.borderBoxSize[0].inlineSize}px`);
        this.sizeGuideContainer.style.transform = `translate(-100%,${window.scrollY}px)`;
      }
    });
    this.resizeObserver.observe(this.sizeGuideContainer);
  }

  disconnectedCallback() {
    this.removeEventListener('keyup', this.bindedHandleKeyUp);
    this.removeEventListener('click', this.bindedHandleClick);
    this.resizeObserver.disconnect();
  }

  handleKeyUp = (event) => {
    if (event.key !== 'Escape') return;

    this.close();
  };

  handleClick(event) {
    if (event.target.closest('.close-size-guide-button') || !event.target.closest('.product__size-guide')) {
      this.sizeGuideContainer.classList.contains('open')? this.close() : this.open();
    }
  }

  open() {
    this.sizeGuideContainer.style.transform = `translate(-100%,${window.scrollY}px)`;
    document.body.style.transform = 'translateX(var(--size-guide-width))';
    this.sizeGuideContainer.classList.add('open');
    this.sizeGuideButton.setAttribute('aria-expanded', 'true');
    this.closeSizeGuideButton.setAttribute('aria-expanded', 'true');
  }

  close() {
    this.sizeGuideContainer.removeAttribute('style');
    document.body.removeAttribute('style');
    this.sizeGuideContainer.classList.remove('open');
    this.sizeGuideButton.setAttribute('aria-expanded', 'false');
    this.closeSizeGuideButton.setAttribute('aria-expanded', 'false');
  }
}

customElements.define('size-guide', SizeGuide);

class FAQQuestion extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');

    this.bindedHandleClick = this.handleClick.bind(this);

    this.summary.addEventListener('click', this.bindedHandleClick);
  }

  disconnectedCallback() {
    this.summary.removeEventListener('click', this.bindedHandleClick);
  }

  handleClick(event) {
    if (this.details.hasAttribute('open')) {
      this.details.setAttribute('aria-expanded', 'false');
    } else {
      this.details.setAttribute('aria-expanded', 'true');
    }
  }
}

customElements.define('faq-question', FAQQuestion);

class EmailPopup extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (!document.cookie.split("; ").find((row) => row.startsWith("email-popup"))) {
      setTimeout(() => {
        this.classList.add('active');
      }, 3000);
    }

    this.closeButton = this.querySelector('.icon-close');
    this.bindedHandleClick = this.handleClick.bind(this);

    this.closeButton.addEventListener('click', this.bindedHandleClick);
  }

  disconnectedCallback() {
    this.closeButton.removeEventListener('click', this.bindedHandleClick);
  }

  handleClick() {
    this.classList.remove('active');

    document.cookie = "email-popup=closed; max-age=2592000";
  }
}

customElements.define('email-popup', EmailPopup);

class BackInStockDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.drawerButton = this.querySelector('button.back-in-stock-drawer-button');
    this.closeDrawerButton = this.querySelector('button.close-back-in-stock-drawer-button');
    this.drawerContainer = this.querySelector('.product__back-in-stock-drawer');
    this.statusSpan = this.querySelector('.back-in-stock-drawer-form__status');
    
    document.documentElement.style.setProperty("--back-in-stock-drawer-width", `${this.drawerContainer.clientWidth}px`);
        
    this.bindedHandleKeyUp = this.handleKeyUp.bind(this);
    this.bindedHandleClick = this.handleClick.bind(this);

    this.addEventListener('keyup', this.bindedHandleKeyUp);
    this.addEventListener('click', this.bindedHandleClick);

    this.resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        document.documentElement.style.setProperty("--back-in-stock-drawer-width", `${entry.borderBoxSize[0].inlineSize}px`);
        this.drawerContainer.style.transform = `translate(-100%,${window.scrollY}px)`;
      }
    });
    this.resizeObserver.observe(this.drawerContainer);

    this.form = this.querySelector('form');
    this.bindedHandleSubmit = this.handleSubmit.bind(this);

    this.form.addEventListener('submit', this.bindedHandleSubmit);
  }

  handleKeyUp = (event) => {
    if (event.key !== 'Escape') return;

    this.close();
  };

  handleClick(event) {
    if (event.target.closest('.close-back-in-stock-drawer-button') || !event.target.closest('.product__back-in-stock-drawer')) {
      this.drawerContainer.classList.contains('open')? this.close() : this.open();
    }
  }

  open() {
    this.drawerContainer.style.transform = `translate(-100%,${window.scrollY}px)`;
    document.body.style.transform = 'translateX(var(--back-in-stock-drawer-width))';
    this.drawerContainer.classList.add('open');
    this.drawerButton.setAttribute('aria-expanded', 'true');
    this.closeDrawerButton.setAttribute('aria-expanded', 'true');
  }

  close() {
    this.drawerContainer.removeAttribute('style');
    document.body.removeAttribute('style');
    this.drawerContainer.classList.remove('open');
    this.drawerButton.setAttribute('aria-expanded', 'false');
    this.closeDrawerButton.setAttribute('aria-expanded', 'false');
  }

  handleSubmit(event) {
    event.preventDefault();

    const email = this.form.querySelector('input[name="email"]').value;
    const variantID = this.form.querySelector('input[name="variantID"]').value;
    const productID = this.form.querySelector('input[name="productID"]').value;

    const url = 'https://app.stoqapp.com/api/v1/intents.json';
    const body = {
      intent: {
        shopify_variant_id: variantID,
        shopify_product_id: productID,
        channel: 'email',
        quantity: 1,
        source: 'api'
      },
      customer: {
        email
      }
    }

    const options = {
      method: 'POST',
      headers: {
        'X-Shopify-Shop-Domain': 'alsolis.myshopify.com',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    };

    fetch(url, options)
      .then(async res => {
        if (res.status == 201) {
          const successHTML = new DOMParser().parseFromString('Thank you <span class="h3-italic">Obrigado</span>', 'text/html');
          this.statusSpan.innerHTML = successHTML.documentElement.innerHTML;
        } else {
          const resBody = await res.json();

          if (resBody?.errors?.already_registered) {
            this.statusSpan.textContent = "You've already registered with this email."
          } else {
            this.statusSpan.textContent = "There's been an error, please try again."
          }
        }
      })
      .then(() => {
        this.statusSpan.classList.add('active');
      })
      .catch(err => console.error(err));
  }
}

customElements.define('back-in-stock-drawer', BackInStockDrawer);